export { LocaleContext as default } from 'choerodon-ui/dataset';
